var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { del, get, put } from 'common/utils/request';
import { prepareParamsToQueryString } from 'common/helpers/prepare-params-to-query-string';
import { CHAT_URL } from 'common/constants/common';
var chatRequestSettings = { baseURL: CHAT_URL };
export var fetchChatMembersApi = function (_a) {
    var chatId = _a.chatId, page = _a.page, pageSize = _a.pageSize, fullNameFilter = _a.fullNameFilter;
    return get("/Chats/".concat(chatId, "/members").concat(prepareParamsToQueryString({
        page: page,
        pageSize: pageSize,
        fullNameFilter: fullNameFilter,
    }, true)), {}, __assign({ abortRequestKey: 'chatFetchMembers' }, chatRequestSettings));
};
export var addChatMembersApi = function (_a) {
    var chatId = _a.chatId, members = __rest(_a, ["chatId"]);
    return put("/Chats/".concat(chatId, "/members"), members, chatRequestSettings);
};
export var removeChatMembersApi = function (_a) {
    var chatId = _a.chatId, members = _a.members;
    return del("/Chats/".concat(chatId, "/members"), { members: members }, chatRequestSettings);
};
export var leaveChatApi = function (_a) {
    var chatId = _a.chatId;
    return del("/Chats/".concat(chatId, "/members/me"), {}, chatRequestSettings);
};
